import React, {
	useState, useEffect, useRef,
} from 'react';
import { useParams, useOutletContext } from 'react-router-dom';

import { fetchData } from '../../../helpers/methods';

import SpinnerContainer from '../../../component-library/spinner-container';

import Update from './sub-components/update';

const ProviderUpdates = () => {
	const { uiMenuConfig } = useOutletContext();
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [allUpdatesData, setAllUpdatesData] = useState([]);
	const allUpdatesDataRef = useRef();
	allUpdatesDataRef.current = allUpdatesData;
	const [totalResults, setTotalResults] = useState(0);
	const totalResultsRef = useRef();
	totalResultsRef.current = totalResults;
	const [pageOffset, setPageOffset] = useState(0);
	const pageOffsetRef = useRef();
	pageOffsetRef.current = pageOffset;
	const pageSize = 20;

	const getAllUpdatesData = () => {
		fetchData({
			uri: `/api/web/notices/catitem/${id}?pageSize=${pageSize}`,
			method: 'GET',
		})
			.then(res => {
				const newAllUpdatesData = res.body.conversation.comments;
				const newTotalResults = res.body.conversation.conversation.last;
				setTotalResults(newTotalResults);
				setPageOffset(0);
				setAllUpdatesData(newAllUpdatesData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const getAllUpdatesDataPaginated = newOffset => {
		fetchData({
			uri: `/api/web/notices/catitem/${id}?pageSize=${pageSize}&offset=${newOffset}`,
			method: 'GET',
		})
			.then(res => {
				const newUpdates = res.body.conversation.comments;
				const newTotalResults = res.body.conversation.conversation.last;
				let newAllUpdatesData = allUpdatesDataRef.current;
				newAllUpdatesData = [...newAllUpdatesData, ...newUpdates];
				setTotalResults(newTotalResults);
				setAllUpdatesData(newAllUpdatesData);
				setLoading(false);
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const handleScroll = () => {
		const container = document.getElementById('mainContainer');
		if (window.innerHeight + window.pageYOffset >= container.offsetHeight + 61) {
			const newPageOffset = pageOffsetRef.current + pageSize;
			if (newPageOffset <= totalResultsRef.current) {
				setPageOffset(newPageOffset);
				getAllUpdatesDataPaginated(newPageOffset);
			}
		}
	};

	useEffect(() => {
		getAllUpdatesData();
		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<>
			<div className="flex-row justify-space-between align-items-flex-start border-bottom margin-bottom-16">
				<h3>{uiMenuConfig?.providerUpdates?.label || 'Provider Updates'}</h3>
			</div>
			{loading && (
				<SpinnerContainer padding={false} />
			)}
			{!loading && (
				<div className="margin-bottom-24">
					{allUpdatesData?.length ? (
						allUpdatesData.map((update, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<Update update={update} key={index} />
						))
					) : (
						<p className="grey-text">No updates found</p>
					)}
				</div>
			)}
		</>
	);
};

export default ProviderUpdates;
